// Services Index - Export real mining services

export { default as miningServices, apiClient } from './api';
export { default as persistenceService } from './persistence';
export { default as ipScannerService } from './ipScanner';

// Keep other services for future use but don't import them in main components yet
export { default as scrapingService, dataProcessors } from './scraping';
export { default as wsService, miningWebSocket, mockWebSocketServer } from './websocket';
export { default as cacheService, cachedMiningServices, CACHE_KEYS, CACHE_TTL } from './cache';

// Re-export types for convenience
export type { WebSocketMessage } from './websocket';
export type { MinerDevice, ScanProgress, ScanResult } from './ipScanner';